import {makeStyles} from "@material-ui/core";

export default function useStyles() {
    return makeStyles((theme) => ({
        imagemFundo: {
            height: '100vh',    
            backgroundSize: 'cover',
            display: 'flex',
            alignItems: 'center'
        },
        cardLogin: {
            maxHeight: '800px'
        }
    }));
}